import * as go from 'gojs';
import type { Group } from 'store/units/types';
import { hexToRgba } from 'util/hexToRgba';

const $ = go.GraphObject.make;

export type GroupNodeData = Group & {
  isGroup: boolean;
  category: 'highlight';
  selected: boolean;
};

export const groupTemplate = $(
  go.Group,
  'Vertical',
  {
    selectionAdorned: false,
    movable: false,
    selectable: false,
  },
  $(
    go.Panel,
    'Auto',
    $(
      go.Shape,
      'RoundedRectangle',
      {
        parameter1: 4,
      },
      new go.Binding('strokeWidth', 'selected', (selected) =>
        selected ? 2 : 1,
      ),
      new go.Binding('stroke', 'color', (color) => color),
      new go.Binding('fill', 'color', (color) => hexToRgba(color, 0.2)),
    ),
    $(go.Placeholder, { margin: new go.Margin(4, 4, 4, 4) }),
  ),
);
